/** Como se escriben los numeros en pantalla. Un solo sitio, para que todo el panel diga igual. */

const dinero = new Intl.NumberFormat('es-EC', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })
const dineroExacto = new Intl.NumberFormat('es-EC', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 })
const numero = new Intl.NumberFormat('es-EC', { maximumFractionDigits: 2 })

export const usd = (v: number) => dinero.format(v)
export const usdExacto = (v: number) => dineroExacto.format(v)
export const num = (v: number) => numero.format(v)
export const pct = (v: number | null, decimales = 1) =>
  v === null ? '—' : `${(v * 100).toLocaleString('es-EC', { maximumFractionDigits: decimales })} %`
export const anios = (v: number | null) =>
  v === null ? 'No se recupera' : `${v.toLocaleString('es-EC', { maximumFractionDigits: 1 })} años`
export const fechaCorta = (iso: string) =>
  new Date(iso).toLocaleDateString('es-EC', { day: '2-digit', month: 'short', year: 'numeric' })

/** Lo contrario: texto de un input a numero. '' es "no puesto" (null); acepta coma decimal. */
export function leerNumero(texto: string): number | null {
  const limpio = texto.trim().replace(',', '.')
  if (limpio === '') return null
  const valor = Number(limpio)
  return Number.isFinite(valor) ? valor : Number.NaN
}
